/** The four datasets legacy RITA draws as slices of one map marker, in slice order. */
export const MAP_REPORTS = ['RPU', 'SOH', 'RIC', 'REL'] as const;

export type MapReport = (typeof MAP_REPORTS)[number];

/** Legacy's own layer ids (`mapping.js` `layers`), kept so URLs read the same as the legacy state. */
export const MAP_LAYER_IDS = ['slc', 'clc', 'acs', 'ips', 'clr', 'clt'] as const;

export type MapLayerId = (typeof MAP_LAYER_IDS)[number];

export type ReportValues = Record<MapReport, number>;
